import { useFilters } from "@context/filters";
import React, { Dispatch, SetStateAction, useEffect } from "react";

interface FiltersContextInterface {
  filters: { [x: string]: any };
  setFilters: (id: string, data: any) => void;
  resetFilters: () => void;
  setInternalFilters: Dispatch<SetStateAction<{ [x: string]: any }>>;
}

export const useFiltersProvider = (): FiltersContextInterface => {
  const [filters, setInternalFilters] = React.useState<{ [x: string]: any }>(
    {},
  );

  const setFilters = (id: string, data: any) => {
    setInternalFilters({ ...filters, [id]: data });
  };

  const resetFilters = () => {
    setInternalFilters({});
  };

  return { filters, setFilters, resetFilters, setInternalFilters };
};

export const useResetFilters = (filterId: string | null = null) => {
  const { filters, resetFilters, setFilters } = useFilters();

  useEffect(() => {
    if (Object.keys(filters).length > 0 && !filterId) {
      resetFilters();
    }
  }, [resetFilters]);

  useEffect(() => {
    if (filterId) {
      return () => {
        setFilters(filterId, {});
      };
    }
  }, []);
};
